var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.23291L1 3.48985C1 2.13982 2.07452 1.04541 3.4 1.04541L7.075 1.04541M4.6 12.0454L8.65 12.0454C9.39558 12.0454 10 11.4298 10 10.6704L10 4.71208C10 3.95269 9.39558 3.33708 8.65 3.33708L4.6 3.33708C3.85442 3.33708 3.25 3.95269 3.25 4.71208L3.25 10.6704C3.25 11.4298 3.85441 12.0454 4.6 12.0454Z",
    stroke: "#CFCED4",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.11a029559b642473cba964a26bf420c9.svg";
export { ForwardRef as ReactComponent };